import React, { useState, useEffect } from "react";
import useStorageState from "@/hooks/useStorageState";
import { createModel } from "hox";
import { IInAndOutSearch, IInAndOutDetail, IInAndOutStatistics } from "./inAndOutTypes"
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, mianCode } from "@/utils/constants";
import { IPgProps, ISearchPage } from "@/types/SCMTypes";
import { inAndOutService } from "./inAndOutService";
import { transPgToPagination, formatNum } from "@/utils/utils";
export const useInAndOutModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<IInAndOutDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IInAndOutSearch>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc: IInAndOutStatistics = {
        ioNum: 0,
        ioAomunt: 0,
        outNum: 0,
        outAomunt: 0,
    }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [descTotal, setDescTotal] = useState<IInAndOutStatistics>(initDesc);


    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<IInAndOutStatistics>(initDesc);
    const [descRows, setDescRows] = useState<IInAndOutDetail[]>([]);
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { num, amount, ioFlag } = item
            newRowsDescTotal.ioNum += ioFlag === 1 ? +formatNum(num) : 0
            newRowsDescTotal.ioAomunt += ioFlag === 1 ? +formatNum(amount) : 0
            newRowsDescTotal.outNum += ioFlag === 0 ? +formatNum(num) : 0
            newRowsDescTotal.outAomunt += ioFlag === 0 ? +formatNum(amount) : 0
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])

    const loadData = async (page?: ISearchPage, searchValue: IInAndOutSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await inAndOutService.ioTotal(searchParams);
        const { records, statistics, ...pg } = retData;
        setPgCfg(transPgToPagination({ ...pg, pageNum: pg.current }));
        setDataSource(records);
        setDescTotal(statistics);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IInAndOutSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    return {
        dataSource,
        searchParam,
        initPgCfg,
        pgCfg,
        selectedRowKeys,
        setDataSource,
        setSearchParam,
        setPgCfg,
        loadData,
        updateSearchParam,
        resetSearchParam,
        setSelectedRowKeys,
        descTotal, setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows
    }
})